import React from 'react';
import { CheckIcon, SunIcon } from 'lucide-react';
export const SustainabilityCommitment = () => {
  return <section className="py-16 bg-gradient-to-r from-green-50 to-blue-50" data-id="element-1287">
      <div className="container mx-auto px-4" data-id="element-1288">
        <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-1289">
          <div className="w-full md:w-1/2" data-id="element-1290">
            <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-1291">
              Our Sustainability Commitment
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-1292">
              Every refurbished device saves up to 100kg of CO<sub data-id="element-1293">2</sub>{' '}
              emissions. Join us in reducing e-waste and building a more
              sustainable future.
            </p>
            <div className="flex flex-col sm:flex-row gap-6 mb-8" data-id="element-1294">
              <div className="flex items-center bg-green-100 rounded-full px-6 py-3" data-id="element-1295">
                <CheckIcon className="h-5 w-5 text-green-600 mr-2" data-id="element-1296" />
                <span className="font-medium" data-id="element-1297">100K+ devices recycled</span>
              </div>
              <div className="flex items-center bg-green-100 rounded-full px-6 py-3" data-id="element-1298">
                <CheckIcon className="h-5 w-5 text-green-600 mr-2" data-id="element-1299" />
                <span className="font-medium" data-id="element-1300">
                  10M+ kg CO<sub data-id="element-1301">2</sub> saved
                </span>
              </div>
            </div>
            <button className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-md font-medium transition-colors" data-id="element-1302">
              Learn More
            </button>
          </div>
          <div className="w-full md:w-1/2 relative" data-id="element-1303">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oyr8LxeYEuXXEfM6EjGP33/image.png" alt="Hand holding smartphone with recycling symbol" className="rounded-lg shadow-lg w-full" data-id="element-1304" />
            <div className="absolute -bottom-6 right-4 bg-white rounded-lg shadow-lg p-4 flex items-center gap-3" data-id="element-1305">
              <div className="bg-green-500 rounded-full p-2" data-id="element-1306">
                <SunIcon className="h-5 w-5 text-white" data-id="element-1307" />
              </div>
              <div data-id="element-1308">
                <div className="font-bold text-gray-800" data-id="element-1309">
                  100% Carbon Neutral
                </div>
                <div className="text-sm text-gray-600" data-id="element-1310">
                  Shipping & Operations
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};